import { Link, useNavigate } from "react-router-dom"; // Import useNavigate
import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import './HomeAbout3.css'; // Import the CSS file for this component

export default function HomeAbout3() {
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false); // Modal state for first image
  const [isModalOpen2, setIsModalOpen2] = useState(false); // Modal state for second image
  const [isHovered1, setIsHovered1] = useState(false); // Hover state for first image
  const [isHovered2, setIsHovered2] = useState(false); // Hover state for second image

  const navigate = useNavigate(); // Initialize the navigate function

  const openModal = () => setIsOpen(!isOpen);

  const openImageModal1 = () => {
    setIsModalOpen1(true);
  };

  const openImageModal2 = () => {
    setIsModalOpen2(true);
  };

  const closeImageModal1 = () => {
    setIsModalOpen1(false);
  };

  const closeImageModal2 = () => {
    setIsModalOpen2(false);
  };

  const handleMouseEnter1 = () => {
    setIsHovered1(true);
  };

  const handleMouseLeave1 = () => {
    setIsHovered1(false);
  };

  const handleMouseEnter2 = () => {
    setIsHovered2(true);
  };

  const handleMouseLeave2 = () => {
    setIsHovered2(false);
  };

  // Function to handle tool card clicks
  const handleToolClick = (path) => {
    navigate(path); // Navigate to the specified path
  };

  return (
    <section
      id="about"
      className="about-us-area pt-155 pb-30 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30"
    >
      <div className="container">
        <div className="row">
          {/* -------- TOOL LIST -------- */}
          <div className="col-lg-7">
            <div className="about-text-wrapper mb-30">
              <h2 className="style-text">Tools</h2>
              <h2 className="sect-title">Messaging Tools We Provide</h2>

              {/* Web inbox */}
              <div className="tool-card" onClick={() => handleToolClick('/web-sms-app')}>
                <div className="tool-icon">
                  <i className="fas fa-comments"></i>
                </div>
                <div className="tool-content">
                  <h3>Web CRM Inbox</h3>
                  <p className="paragraph-title" style={{ color: 'black' }}>
                    A desktop chat that plugs straight into your CRM. Search contacts, reply in
                    threads, and see delivery/read status—no marketing features, just clean account
                    messaging.
                  </p>
                </div>
              </div>

              {/* Bulk sender */}
              <div className="tool-card" onClick={() => handleToolClick('/bulksms')}>
                <div className="tool-icon">
                  <i className="fas fa-paper-plane"></i>
                </div>
                <div className="tool-content">
                  <h3>Bulk Sender</h3>
                  <p className="paragraph-title" style={{ color: 'black' }}>
                    Need to text a whole client list (e.g.&nbsp;invoices, maintenance notices)? Drag
                    in a CSV and queue messages in seconds—or call the same workflow via our
                    Bulk&nbsp;SMS&nbsp;API. <strong>Cold outreach isn’t recommended;</strong> large
                    unsolicited blasts can get a SIM blocked.
                  </p>
                </div>
              </div>

              {/* Two-way API */}
              <div className="tool-card" onClick={() => handleToolClick('/smsapi')}>
                <div className="tool-icon">
                  <i className="fas fa-code"></i>
                </div>
                <div className="tool-content">
                  <h3>Two-Way SMS&nbsp;API</h3>
                  <p className="paragraph-title" style={{ color: 'black' }}>
                    Send OTPs, appointment reminders, and status updates programmatically. Receive
                    replies over webhooks. SDKs for JS, Python, and C# included.
                  </p>
                </div>
              </div>

              {/* GHL Integration */}
              <div className="tool-card">
                <div className="tool-icon">
                  <i className="fas fa-cogs"></i>
                </div>
                <div className="tool-content">
                  <h3>GoHighLevel Connector</h3>
                  <p className="paragraph-title" style={{ color: 'black' }}>
                    Installs as a Conversation Provider so every text, reply, and attachment stays
                    in your GHL pipelines—perfect for service updates and customer support flows.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* -------- IMAGE / VIDEO PREVIEW -------- */}
          {/* existing preview code unchanged */}
        </div>
      </div>

      {/* image modals + video modal logic unchanged */}
    </section>
  );
}